import { formatCurrency } from '@/utils/formatters';

interface DrawdownSummaryProps {
  totalAmount: number;
  totalAmountReceived: number;
  investorsPaidCount: number;
  investorsTotalCount: number;
  currency?: string;
}

export const DrawdownSummary = ({
  totalAmount,
  totalAmountReceived,
  investorsPaidCount,
  investorsTotalCount,
  currency = 'EUR',
}: DrawdownSummaryProps) => {
  const collectionProgress =
    totalAmount > 0 ? (totalAmountReceived / totalAmount) * 100 : 0;

  return (
    <div className="bg-muted/40 rounded-lg px-3 py-3 mb-6 mt-4">
      <div className="flex flex-wrap items-center gap-x-10 gap-y-3">
        <div className="flex items-baseline gap-2">
          <span className="text-muted-foreground text-sm">Total called:</span>
          <span className="font-bold text-lg">
            {formatCurrency(totalAmount, { currency })}
          </span>
        </div>

        <div className="flex items-center gap-2">
          <span className="text-muted-foreground text-sm">Received:</span>
          <span className="font-bold text-lg text-green-600">
            {formatCurrency(totalAmountReceived, { currency })}
          </span>
          <span className="text-sm text-muted-foreground">
            ({investorsPaidCount}/{investorsTotalCount} •{' '}
            {collectionProgress.toFixed(1)}%)
          </span>
          <span className="h-1.5 w-14 overflow-hidden rounded-full bg-muted">
            <span
              className="block h-full rounded-full bg-green-500"
              style={{ width: `${Math.min(collectionProgress, 100)}%` }}
            />
          </span>
        </div>
      </div>
    </div>
  );
};
